import React, { Component } from 'react';
import s from './History.css';

export default class Story extends Component {

  catColor(category){
    return "#abc";
  }

  render(){
    const story = this.props.story;
    return pug`
      div(className=s.story)
        header(className=s.header)
          div(className=s.when)= story.when
          div(className=s.categories)
            each category,i in story.categories
              div(className=s.category 
                style={backgroundColor:this.catColor(category)} key=i)= category
              

        div(className=s.body)
          if story.img
            if story.url
              a(href=story.url)
                img(className=s.thumb src=story.img)
            else 
              img(className=s.thumb src=story.img)
          div(className=s.text)
            if story.url
              a(className=s.link href=story.url)
                h3(className=s.title_url)= story.title
                if story.url 
                  p(className=s.url)= story.url
            else
              h3(className=s.title)= story.title
              

            if story.roles
              p(className=s.roles)= story.roles.join(" ")
            if story.desc
              p(className=s.desc)= story.desc

          
    `;
  }

}



// WEBPACK FOOTER //
// ./src/Story.js